var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { any, func, node, string } from 'prop-types';
import styles from './Button.scss';
import WixComponent from '../../BaseComponents/WixComponent';
import ButtonLayout from '../../ButtonLayout/ButtonLayout';
import omit from 'omit';

var Button = function (_WixComponent) {
  _inherits(Button, _WixComponent);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.addPrefix = _this.addPrefix.bind(_this);
    _this.addSuffix = _this.addSuffix.bind(_this);
    _this.addIcon = _this.addIcon.bind(_this);
    return _this;
  }

  _createClass(Button, [{
    key: 'addIcon',
    value: function addIcon(className, icon, height) {
      var iconSize = height === 'small' ? '8px' : height === 'medium' ? '12px' : '16px';
      var dataHook = className === styles.prefix ? 'btn-prefix' : 'btn-suffix';
      return icon ? React.createElement(
        'div',
        { className: className, 'data-hook': dataHook },
        React.cloneElement(icon, { size: iconSize })
      ) : null;
    }
  }, {
    key: 'addPrefix',
    value: function addPrefix() {
      return this.addIcon(styles.prefix, this.props.prefixIcon, this.props.height);
    }
  }, {
    key: 'addSuffix',
    value: function addSuffix() {
      return this.addIcon(styles.suffix, this.props.suffixIcon, this.props.height);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          onClick = _props.onClick,
          children = _props.children,
          type = _props.type,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave;

      var buttonLayoutProps = omit(['id', 'onClick', 'prefixIcon', 'suffixIcon', 'type'], this.props);
      return React.createElement(
        ButtonLayout,
        buttonLayoutProps,
        React.createElement(
          'button',
          { onClick: onClick, disabled: disabled, type: type, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
          this.addPrefix(),
          children,
          this.addSuffix()
        )
      );
    }
  }]);

  return Button;
}(WixComponent);

Button.propTypes = _extends({}, ButtonLayout.propTypes, {
  children: any,
  id: string,
  prefixIcon: node,
  suffixIcon: node,
  type: string,
  onClick: func,
  onMouseEnter: func,
  onMouseLeave: func
});
Button.defaultProps = ButtonLayout.defaultProps;


Button.displayName = 'Button';

export default Button;
//# sourceMappingURL=Button.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Backoffice/Button/Button.js